/**
 * @file
 * Adds/removes 'select-open' on selects while their native dropdown is open.
 *
 * Usage: add class "js-select-open-detect" to the <select>.
 */

(function (Drupal, once) {
  'use strict';

  // Keep handler references for proper cleanup on detach.
  const handlerMap = new WeakMap();

  Drupal.behaviors.selectOpenState = {
    attach(context) {
      const selects = once("selectOpenState", "select.js-select-open-detect", context);

      selects.forEach((el) => {
        const OPEN_CLASS = "select-open";

        const addOpen = () => el.classList.add(OPEN_CLASS);
        const removeOpen = () => el.classList.remove(OPEN_CLASS);

        // Heuristics to detect "opening": user presses keys that open, or mousedown.
        const onMouseDown = (e) => {
          // Only primary button.
          if (e.button && e.button !== 0) return;
          // Defer to next tick so the browser can process focus/open first.
          setTimeout(addOpen, 0);
        };

        const onKeyDown = (e) => {
          // Keys that typically open a native select.
          if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === " " || e.key === "Enter") {
            setTimeout(addOpen, 0);
          }
          // ESC reliably closes.
          if (e.key === "Escape") {
            removeOpen();
          }
        };

        // These usually indicate the dropdown has closed.
        const onBlur = () => removeOpen();
        const onChange = () => setTimeout(removeOpen, 0);

        // Click/tap anywhere else closes.
        const onDocPointerDown = (e) => {
          if (e.target !== el) removeOpen();
        };

        el.addEventListener("mousedown", onMouseDown);
        el.addEventListener("keydown", onKeyDown);
        el.addEventListener("blur", onBlur);
        el.addEventListener("change", onChange);
        // Use capture to catch early and be resilient to stopPropagation.
        document.addEventListener("pointerdown", onDocPointerDown, { capture: true });

        handlerMap.set(el, {
          onMouseDown,
          onKeyDown,
          onBlur,
          onChange,
          onDocPointerDown,
        });
      });
    },

    detach(context, settings, trigger) {
      // Clean up only on full element unload.
      if (trigger !== "unload") return;

      // Remove listeners from any selects that are being detached.
      const selects = once.remove("selectOpenState", "select.js-select-open-detect", context);
      selects.forEach((el) => {
        const h = handlerMap.get(el);
        if (!h) return;
        el.removeEventListener("mousedown", h.onMouseDown);
        el.removeEventListener("keydown", h.onKeyDown);
        el.removeEventListener("blur", h.onBlur);
        el.removeEventListener("change", h.onChange);
        document.removeEventListener("pointerdown", h.onDocPointerDown, { capture: true });
        handlerMap.delete(el);
      });
    },
  };
})(Drupal, once);
